import * as React from 'react';

import { NBSP } from '../../constants';
import { trackOpenRoadsLink } from '../../tracking';
import styles from '../village_info/VillageInfo.css';

interface IProps {
  roadName: string;
  roadLink: string;
  distance?: string;
}

export const RoadItem = (props: IProps) => {
  const { roadName, roadLink, distance } = props;

  if (!roadName || !distance) {
    return null;
  }

  return (
    <div className={styles['highway']}>
      <a className={styles['address-link']} href={roadLink} onClick={trackOpenRoadsLink} target="_blank">
        <span>{roadName}</span>
      </a>
      ,{NBSP}
      <span className={styles['distance']}>{distance}</span>
    </div>
  );
};
